<div>
    <div v-for="summary in compartmentProductsSummary" >
        <div v-if="summary.isViewable">
            <label>{{summary.compartmentName}} <span v-if="summary.upliftedQuantity !== null">(Uplifted Quantity: {{summary.upliftedQuantity}}L)</span></label>
            <div class="progress mb-0 mt-0">
                <div class="progress-bar" role="progressbar" :style="{width: summary.percentageOfMaxCapacity + '%'}"
                     aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">{{convertPercentageToTwoDecimalPlaces(summary.percentageOfMaxCapacity)}}%
                </div>
            </div>
            <p>{{summary.instructedQuantity}}L of {{summary.compartmentMaxCapacity}}L</p>
        </div>
        
    </div>
    <div class="text-danger" v-if="canAssignCompartments === false && !viewOnly">
        The selected vehicle does not have compartments that can hold the products for this order. Please select another vehicle.
    </div>
    
    <data-table :headings="orderItemsHeadings"
                :data="orderItems"
                :hasActions="true"
                :hasCustomActionComponent="true"
                :pagingDetails="pagingDetails"
                :hasNoFilter="true"
                v-if="!viewOnly">
        <template #actionComponent="{ orderItemId, canAssignProductsToVehicleCompartments }">
            <button class="btn btn-primary" @click="onAssignCompartmentsClick(orderItemId)" :disabled="!canAssignProductsToVehicleCompartments">
                Assign Compartments
            </button>
        </template>
    </data-table>

    <data-table :headings="orderItemsHeadings"
                :data="orderItems"
                :hasActions="false"
                :hasCustomActionComponent="false"
                :hasNoFilter="true"
                :hasNoPaging="true"
                v-if="viewOnly">
    </data-table>
</div>